/**
 * Hydriert RichText-Platzhalter im DOM: `.rt-math` → KaTeX, `.rt-mermaid` → SVG.
 *
 * Läuft nach dem Mount/Update von RichText.svelte. Beide Bibliotheken werden
 * lazy geladen — Karten ohne Mathe/Diagramm kosten nichts. Fehlerfälle lassen
 * den lesbaren Quelltext-Fallback stehen.
 */
import { getKatex } from '$lib/katex/loader';
import { renderMermaid } from '$lib/mermaid/loader';

let mermaidSeq = 0;

export async function hydrateRichExtras(root: HTMLElement): Promise<void> {
  const maths = Array.from(root.querySelectorAll<HTMLElement>('.rt-math:not([data-hydrated])'));
  if (maths.length) {
    try {
      const katex = await getKatex();
      for (const el of maths) {
        const tex = decodeURIComponent(el.dataset.tex ?? '');
        try {
          katex.render(tex, el, { displayMode: el.dataset.display === '1', throwOnError: false });
          el.dataset.hydrated = '1';
        } catch {
          // Fallback (escaptes TeX) bleibt sichtbar
        }
      }
    } catch {
      // KaTeX nicht ladbar → alle Fallbacks bleiben
    }
  }

  const diagrams = Array.from(
    root.querySelectorAll<HTMLElement>('.rt-mermaid:not([data-hydrated])'),
  );
  for (const el of diagrams) {
    const code = decodeURIComponent(el.dataset.code ?? '');
    try {
      const { svg } = await renderMermaid(`rt-mermaid-${++mermaidSeq}`, code);
      el.innerHTML = svg;
      el.dataset.hydrated = '1';
    } catch {
      // Fallback (<pre> mit Quelltext) bleibt
    }
  }
}
